import {useEffect} from 'react';
import {useHubSpot} from '../hooks';
import {useUserContext} from './UserContext';

export function HubSpotLoader({children}) {
    const {
        clear,
        load,
        setUserEmail,
        waitForHubSpotToInit,
    } = useHubSpot();
    const {user} = useUserContext();

    useEffect(() => {
        let cancelled = false;

        const initializeHubSpot = async () => {
            await waitForHubSpotToInit();
            if (cancelled) {
                // If this "useEffect" has been cancelled (maybe due to the user changing), we don't want to continue
                // initializing HubSpot and setting the user's email.
                return;
            }

            clear();
            if (user?.emailVerified && user?.hsVerificationToken) {
                setUserEmail(user.emailAddress, user.hsVerificationToken);
            }

            // In order for `setUserEmail` to work, there must have been a previous `clear` call and a subsequent
            // `load` call.
            load();
        };

        initializeHubSpot();

        return () => {
            cancelled = true;
        };
    }, [user]);

    return children;
}
